import React, { createContext, useContext, useState, type ComponentProps } from "react";
import { Select, SelectContent } from "@/components/ui/select";

const OpenContext = createContext(false);

// Radix normally evaluates closed option lists in a detached fragment. Keep
// inventory's larger lists unmounted until the visitor opens the control.
export function DeferredInventorySelect(props: ComponentProps<typeof Select>) {
  const [open, setOpen] = useState(false);
  return (
    <OpenContext.Provider value={open}>
      <Select {...props} open={open} onOpenChange={setOpen} />
    </OpenContext.Provider>
  );
}

export function DeferredInventorySelectContent(props: ComponentProps<typeof SelectContent>) {
  const open = useContext(OpenContext);
  return open ? <SelectContent {...props} /> : null;
}